import type { Lead, LeadWithIntelligence } from '../api/types';

const STAGE_LABELS: Record<string, string> = {
  new: 'Nuevo',
  researching: 'Investigando',
  outreach: 'Outreach',
  conversation: 'Conversación',
  diagnostic: 'Diagnóstico',
  proposal: 'Propuesta',
  negotiation: 'Negociación',
  won: 'Ganado',
  lost: 'Perdido',
  dormant: 'Inactivo',
};

export function stageLabel(stage: string): string {
  return STAGE_LABELS[stage] || stage;
}

export function timeAgo(dateStr: string | Date | number | null | undefined): string {
  if (!dateStr) return '';
  const d = new Date(dateStr);
  if (isNaN(d.getTime())) return '';
  const now = Date.now();
  const diff = now - d.getTime();
  const seconds = Math.floor(diff / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);

  if (days > 30) return formatDate(dateStr);
  if (days > 0) return `${days}d atrás`;
  if (hours > 0) return `${hours}h atrás`;
  if (minutes > 0) return `${minutes}m atrás`;
  return 'ahora';
}

export function formatDate(dateStr: string | Date | number | null | undefined): string {
  if (!dateStr) return '—';
  const d = new Date(dateStr);
  if (isNaN(d.getTime())) return '—';
  return d.toLocaleDateString('es-MX', { day: 'numeric', month: 'short', year: 'numeric' });
}

export function pad2(n: number): string {
  return n < 10 ? `0${n}` : `${n}`;
}

const ENRICH_FIELDS = [
  { key: 'contactName', label: 'Contacto' },
  { key: 'contactEmail', label: 'Email' },
  { key: 'contactPhone', label: 'Teléfono' },
  { key: 'websiteUrl', label: 'Web' },
  { key: 'sector', label: 'Sector' },
  { key: 'painPoint', label: 'Pain point' },
  { key: 'commercialAngle', label: 'Ángulo comercial' },
  { key: 'uspVerified', label: 'USP verificado' },
];

export function countMissing(lead: Lead | LeadWithIntelligence | Record<string, unknown>): number {
  let n = 0;
  if (!lead.contactEmail) n++;
  if (!lead.contactPhone) n++;
  if (!lead.contactName) n++;
  if (!lead.websiteUrl) n++;
  return n;
}

export function completeness(lead: Lead | LeadWithIntelligence | Record<string, unknown>): number {
  let filled = 0;
  const l = lead as Record<string, unknown>;
  for (const f of ENRICH_FIELDS) {
    const v = l[f.key];
    if (v && String(v).trim()) filled++;
  }
  return Math.round((filled / ENRICH_FIELDS.length) * 100);
}

export function getEnrichFields() {
  return ENRICH_FIELDS;
}
